import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faListOl } from "@fortawesome/free-solid-svg-icons"

export const OrdonedList = (props) => {
  return <FontAwesomeIcon faIcon={faListOl} {...props} />
}
